import Image from "next/image";

interface MarqueeProps {
  images: string[];
  width?: number;
  height?: number;
  direction?: "horizontal" | "vertical";
  reversed?: boolean;
  speed?: number;
  imageMult?: number;
  borderRadius?: number;
  gap?: number;
  border?: string;
}

export const Marquee = ({
  images,
  width = 150,
  height = 200,
  direction = "horizontal",
  reversed = false,
  speed = 100,
  imageMult = 3,
  borderRadius = 10,
  gap = 16,
  border,
}: MarqueeProps) => {
  const isHorizontal = direction === "horizontal";
  const repeatedImages = Array(imageMult).fill(images).flat();

  return (
    <div className="group">
      <style>
        {`
          @keyframes marqueeScroll {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(calc(-${width}px * ${images.length}));
            }
          }

          @keyframes marqueeScrollReversed {
            0% {
              transform: translateX(calc(-${width}px * ${images.length}));
            }
            100% {
              transform: translateX(0);
            }
          }

          @keyframes marqueeScrollVertical {
            0% {
              transform: translateY(0);
            }
            100% {
              transform: translateY(calc(-${height}px * ${images.length}));
            }
          }

          @keyframes marqueeScrollVerticalReversed {
            0% {
              transform: translateY(calc(-${height}px * ${images.length}));
            }
            100% {
              transform: translateY(0);
            }
          }
        `}
      </style>
      <div
        className={`group-hover:[animation-play-state:paused] whitespace-nowrap ${
          isHorizontal ? "flex-row" : "flex-col"
        }`}
        style={{
          animation: isHorizontal
            ? reversed
              ? `marqueeScrollReversed ${speed}s linear infinite`
              : `marqueeScroll ${speed}s linear infinite`
            : reversed
              ? `marqueeScrollVerticalReversed ${speed}s linear infinite`
              : `marqueeScrollVertical ${speed}s linear infinite`,
          gap,
          display: "flex",
        }}
      >
        {repeatedImages.map((img, id) => (
          <div
            className={`flex items-center`}
            key={id}
            style={{
              width,
              height,
            }}
          >
            <div className={`relative w-full h-full`}>
              <Image
                src={img}
                alt={`marquee-${id}`}
                fill
                className={`object-cover object-center ${border}`}
                style={{
                  borderRadius,
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
